import {JwksValidationHandler, OAuthService, OAuthSuccessEvent} from 'angular-oauth2-oidc';
import {Injectable, isDevMode} from '@angular/core';
import {oidcAuthConfig} from './oidc.auth.config';

@Injectable()
export class AuthenticationService {

  constructor(private oauthService: OAuthService) {
  }

  isLoggedIn(): boolean {
    return this.oauthService.hasValidIdToken() && this.oauthService.hasValidAccessToken();
  }

  logOut(): void {
    this.oauthService.logOut();
  }

  configureWithNewConfigApi() {
    if (isDevMode()) {
      this.oauthService.events.subscribe(e => console.log(e));
    }
    this.oauthService.events.subscribe((e: OAuthSuccessEvent) => {
      if (e.type === 'silent_refresh_timeout') {
        this.refresh();
      }
    });
    this.oauthService.configure(oidcAuthConfig);
    this.oauthService.setStorage(localStorage);
    this.oauthService.tokenValidationHandler = new JwksValidationHandler();
    this.oauthService.setupAutomaticSilentRefresh();

    return this.oauthService.loadDiscoveryDocumentAndLogin();
  }

  authorizationHeader() {
    return this.oauthService.authorizationHeader();
  }

  getAuthenticatedUserName() {
    const claims: any = this.oauthService.getIdentityClaims();
    if (!claims) {
      return null;
    }
    return claims.name;
  }

  refresh() {
    if (isDevMode()) {
      console.log('silentRefresh');
    }
    this
      .oauthService
      .silentRefresh()
      .then(info => console.log('refresh ok', info))
      .catch(err => console.error('refresh error', err));
  }

}
